//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './css/index.css'
export default {
  data(){
    return{
    }
  },
  methods:{
  },
  mounted(){
  }
}



// WEBPACK FOOTER //
// ./src/components/userInfoHead/index.vue